// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  border: 1px solid var(--gc-border-color);
}

.sidebar {
  transition: 0.25s all;
  transition-timing-function: ease-in;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-shadow: 2px 0 8px var(--gc-box-shadow-color);
  background: var(--gc-background-color);
}
.sidebar .content {
  flex-grow: 1;
}
.sidebar > .header {
  border-bottom: 1px solid var(--gc-border-color);
  cursor: pointer;
  height: 65px;
  padding: 15px 10px;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: var(--gc-color-medium-tint);
  border-radius: 5px;
}

::-webkit-scrollbar-track {
  background: var(--gc-color-light-shade);
}

:host {
  background: var(--gc-background-color);
}

.menu {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.entry .children {
  overflow: hidden;
}
.entry.entry-level-1 {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  margin: 0;
}
.entry.entry-level-1.entry-expanded > .entry-title {
  border-color: var(--gc-border-color) !important;
}
.entry-selected-path, .entry-expanded {
  border-color: var(--gc-border-color) !important;
  background: var(--gc-color-light-tint);
  margin: -1px;
  overflow: hidden;
}
.entry:hover:not(.entry-expanded):not(.entry-selected) {
  background: var(--gc-color-light-shade);
}
.entry-selected {
  background: rgba(var(--gc-color-primary-rgb), 0.5);
  font-weight: bold;
}
.entry-icon {
  flex: 0 0 16px;
  display: flex;
  justify-content: center;
}
.entry-tag {
  white-space: nowrap;
  display: block;
  padding: 0.25rem;
  border-radius: 4px;
  font-size: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  margin: 0 0.5rem;
}
.entry-tags {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
}
.entry-title {
  padding: 15px 10px;
  height: 42px;
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.entry-title .entry-label {
  min-width: 140px;
  width: 100%;
  margin-left: 1rem;
}
.entry-title .entry-label:first-child {
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-general-sidebar/v-general-sidebar.component.sass"],"names":[],"mappings":"AAAA;EACI,wCAAA;AACJ;;AACA;EACI,qBAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gDAAA;EACA,sCAAA;AAEJ;AADI;EACI,YAAA;AAGR;AAFI;EACI,+CAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAIR;;AAHA;EACI,UAAA;AAMJ;;AAJA;EACI,uCAAA;EACA,kBAAA;AAOJ;;AALA;EACI,uCAAA;AAQJ;;AANA;EACI,sCAAA;AASJ;;AAPA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAUJ;;AARI;EACI,gBAAA;AAWR;AAVI;EACI,iCAAA;EACA,oCAAA;EACA,SAAA;AAYR;AAVQ;EACI,+CAAA;AAYZ;AAXI;EACI,+CAAA;EACA,sCAAA;EACA,YAAA;EACA,gBAAA;AAaR;AAZI;EACI,uCAAA;AAcR;AAbI;EACI,kDAAA;EACA,iBAAA;AAeR;AAdI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;AAgBR;AAfI;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAiBR;AAhBI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;AAkBR;AAjBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAmBR;AAjBY;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;AAmBhB;AAlBgB;EACI,cAAA;AAoBpB","sourcesContent":[":host \n    border: 1px solid var(--gc-border-color)\n\n.sidebar\n    transition: 0.25s all\n    transition-timing-function: ease-in\n    display: flex\n    flex-direction: column\n    height: 100%\n    box-shadow: 2px 0 8px var(--gc-box-shadow-color)\n    background: var(--gc-background-color)\n    .content\n        flex-grow: 1\n    > .header\n        border-bottom: 1px solid var(--gc-border-color)\n        cursor: pointer\n        height: 65px\n        padding: 15px 10px\n::-webkit-scrollbar\n    width: 5px\n\n::-webkit-scrollbar-thumb \n    background:  var(--gc-color-medium-tint)\n    border-radius: 5px\n\n::-webkit-scrollbar-track\n    background:  var(--gc-color-light-shade)\n\n:host    \n    background: var(--gc-background-color)\n\n.menu\n    width: 100%\n    display: flex\n    flex-direction: column\n    overflow: auto\n.entry\n    .children\n        overflow: hidden\n    &.entry-level-1\n        border-top: 1px solid transparent\n        border-bottom: 1px solid transparent\n        margin: 0\n        \n        &.entry-expanded > .entry-title\n            border-color: var(--gc-border-color) !important\n    &-selected-path,&-expanded\n        border-color: var(--gc-border-color) !important\n        background: var(--gc-color-light-tint)\n        margin: -1px\n        overflow: hidden\n    &:hover:not(.entry-expanded):not(.entry-selected)\n        background: var(--gc-color-light-shade)\n    &-selected\n        background: rgba(var(--gc-color-primary-rgb), 0.5)\n        font-weight: bold\n    &-icon\n        flex: 0 0 16px\n        display: flex\n        justify-content: center\n    &-tag\n        white-space: nowrap\n        display: block\n        padding: 0.25rem\n        border-radius: 4px\n        font-size: 0.75rem\n        line-height: 0.75rem\n        text-align: center\n        margin: 0 0.5rem\n    &-tags\n        flex-grow: 1\n        display: flex\n        justify-content: flex-end\n    &-title\n        padding: 15px 10px\n        height: 42px\n        width: 100%\n        display: flex\n        align-items: center\n        cursor: pointer\n        .entry\n            &-label\n                min-width: 140px\n                width: 100%\n                margin-left: 1rem\n                &:first-child\n                    margin-left: 0"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
